import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import Auth from "src/Routes/Auth";
import NotFound from "src/Routes/NotFound";
import ProfileCheck from "../ProfileCheck";

interface IProps {
  isLoggedIn: boolean | null;
  isAdmin: boolean | null;
}

const LoggedInRoute: React.SFC<IProps> = ({ isAdmin }) => (
  <Switch>
    <Route
      path="/"
      component={(props) => <ProfileCheck {...props} isAdmin={isAdmin} />}
    />
    <Route
      path="/referral/:username"
      component={(props) => <ProfileCheck {...props} isAdmin={isAdmin} />}
    />
    <Route component={NotFound} />
  </Switch>
);

const LoggedOutRoute = () => (
  <Switch>
    <Route exact path="/" component={Auth} />
    <Route exact path="/referral/:username" component={Auth} />
    <Redirect to="/" />
  </Switch>
);

const AppPresenter: React.SFC<IProps> = ({ isLoggedIn, isAdmin }) => {
  return (
    <BrowserRouter>
      {isLoggedIn ? (
        <LoggedInRoute isLoggedIn={isLoggedIn} isAdmin={isAdmin} />
      ) : (
        <LoggedOutRoute />
      )}
    </BrowserRouter>
  );
};

export default AppPresenter;
